<template>
    <div class="information">
        <el-form ref="informationForm" class="informationForm" label-position="top" :model="formData" :rules="rules" size="small">
            <el-form-item label="主办方名称：" prop="name">
                <el-input v-model="formData.name" placeholder="请输入主办方名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="主办方头像：" prop="avatar" required>
                <el-upload class="upload-demo clear" :show-file-list="false" :action="uploadAction" :on-success="uploadSuccessHandler" :headers="uploadHeaders">
					<img v-if="formData.avatar" :src="formData.avatar" class="avatar fl" >
					<div class="imgBtn fl">{{ formData.avatar ? '重新上传' : '上传图片'}}</div>
					<p class="fl tip">请上传比例是1:1的图，格式不限</p>
                </el-upload>
            </el-form-item>
			<!-- <el-form-item label="图片：" prop="bannerUrls" required>
                <el-upload class="upload-demo clear" :show-file-list="false" :action="uploadAction" :before-upload="beforeBannerUpload" :on-success="uploadBannerHanle" :headers="uploadHeaders">
					<div class="imgBtn fl">上传图片</div>
					<p class="fl tip">请上传宣传图用于给舞者展示，尺寸375*211，最多5张</p>
                </el-upload>
				<div class="bannerUrls" v-if="formData.bannerUrls && formData.bannerUrls.length > 0">
					<div class="bannerUrlsItem" v-for="(item, index) in formData.bannerUrls" :key="'bannerUrls' + index">
						<img :src="item" alt="">
						<div class="close" @click="deleteImgItem(index)"></div>
					</div>
				</div>
            </el-form-item> -->
			<el-form-item label="标签" prop="tags">
				<el-checkbox-group v-model="formData.tags">
					<el-checkbox label="赛事主办"></el-checkbox>
					<el-checkbox label="舞蹈培训"></el-checkbox>
					<el-checkbox label="演出活动"></el-checkbox>
					<el-checkbox label="大师课"></el-checkbox>
				</el-checkbox-group>
			</el-form-item>
            <el-form-item label="主办方地址" prop="province">
              <select-address ref="addres" :passaddress="{ province: formData.province, city: formData.city, district: formData.area }" @changeCity="changeCity"></select-address>
            </el-form-item>
            <el-form-item label="联系人：">
              <el-input v-model="formData.userName" placeholder="请输入联系人" clearable></el-input>
            </el-form-item>
            <el-form-item  label="手机号：" prop="mobile">
				<div class="moblie">
					<el-input class="moblieInput" v-model="formData.mobile" maxlength="11" placeholder="请输入手机号" clearable></el-input>
					<el-button class="getMoblieBtn btn " type="" @click="getMobileCode" v-if="!getMobileCodeI">{{!getMobileCodeState ? '获取验证码' : `${getMobileCodeTime}s后重新获取`}}</el-button>
					<el-button class="getMoblieBtn btn " type="" @click="getMobileCode" v-else>{{!getMobileCodeState ? '重新获取' : `${getMobileCodeTime}s后重新获取`}}</el-button>
				</div>
            </el-form-item>
			<el-form-item label="验证码："  prop="code">
				<el-input v-model="formData.code" maxlength="11" placeholder="请输入验证码" clearable></el-input>
			</el-form-item>
            <el-form-item label="电子邮箱：">
              <el-input v-model="formData.email" placeholder="请输入电子邮箱" clearable></el-input>
            </el-form-item>
			<el-form-item label="简介" prop="description">
				<el-input v-model="formData.description" type="textarea" :autosize="{ minRows: 3, maxRows: 10 }"  maxlength="500" show-word-limit placeholder="写下你的简介，留下联系方式，方便品牌找到你"></el-input>
			</el-form-item>
			<el-form-item>
				<div class="btn" @click="btn">完成注册</div>
			</el-form-item>
        </el-form>
    </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import selectAddress from '@/components/select-address'
import LoginService from '@/services/login';
import { prefix } from '@/api';
import { authToken } from '@/config';
import { storage } from '@/utils';
import * as types from '@/store/mutation-types';
export default {
    components: {
        selectAddress
	},
	props: ['id'],
    data() {
        return {
			uploadAction: `${prefix}/admin/file/upload_image`, // 上传文件
			formData: {
				name: '',
				avatar: '',
				provinceId: '',
				cityId: '',
				address: '',
				userName: '',
				mobile: '',
				code: '',
				email: '',
				tags: [],
				bannerUrls: []
			},
			rules: {
				name: [{ required: true, message: '请输入主办方名称', trigger: 'blur' }],
				avatar: [{ required: true, message: '请上传主办方头像', trigger: 'blur' }],
				mobile: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{ pattern: /^[1]([3-9])[0-9]{9}$/, message: '请输入正确手机号', trigger: 'blur' }
				],
				bannerUrls: [{ required: true, message: '请至少选择一张图片', trigger: 'blur' }],
				tags: [{ required: true, message: '请至少选择一项标签', trigger: 'blur' }],
				code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
				description: [{ required: true, message: '请输入主办方简介', trigger: 'blur' }],
				province: [{ required: true, message: '主办方地址不能为空', trigger: 'blur' }]
			},
			uploadHeaders: {
				token: storage.getItem(authToken)
			},
			getMobileCodeState: false,
			getMobileCodeI: false,
			getMobileCodeTime: 60,
			getMobileCodeTimeHandle: null
        }
    },
    methods: {
		uploadSuccessHandler (esponse, file, fileList) {  //上传logo图
			const { code, result } = esponse;
			if (Object.is(code, 0)) {
				this.formData.avatar = result.url;
			} else {
				this.$message.error('上传失败');
				this.formData.avatar = '';
			}
			console.log(esponse, file, fileList, '上传文件');
		},
		// uploadBannerHanle (esponse) { //上传banner图
		// 	const { code, result } = esponse;
		// 	if (Object.is(code, 0)) {
		// 		this.formData.bannerUrls.push(result.url);
		// 	} else {
		// 		this.$message.error('上传失败');
		// 	}
		// },
		// beforeBannerUpload() { //上传banner图之前 校验
		// 	if(this.formData.bannerUrls.length >= 5) {
		// 		this.$message.error('最多上传5张banner图片');
		// 		return false
		// 	} else {
		// 		return true;
		// 	}
		// },
		deleteImgItem(i) {
			this.formData.bannerUrls.splice(i, 1)
		},
		btn() {
			this.$refs['informationForm'].validate((valid) => {
				if (!valid) return false;
				if(!this.$refs.addres.address.provinceId || !this.$refs.addres.address.cityId || !this.$refs.addres.address.address) {
					this.$message.error('主办方地址不能为空')
					return false
				}
				this.formData.accountId = this.id;
				let data = {
					...this.formData,
					...this.$refs.addres.address,
				}
				LoginService.sponsorInformation(data).then(res => {
					const { code, message, result } = res;
					if(Object.is(code, 0)) {
						this.$message.success('登录成功');
						this.setUserInfo(result);
						storage.setItem(authToken, result.token);
						this.goIndex()
					} else {
						this.$message.error(message)
					}
				})
			})
		},
		async goIndex() {
			const result1 = await this.getMenuListApi();
			// 登录成功去获取菜单接口,请求成功的时候就调整到首页
			if (result1) this.$router.push('/');
		},
		async getMobileCode() {
			if(this.getMobileCodeState) return false;
			const { code, message } = await LoginService.getMobileCode({ mobile: this.formData.mobile })
			if(code == 0) {
				this.getMobileCodeI = true
				this.$message.success('发送成功')
				this.timeHandle()
			} else {
				this.$message.error(message)
			}
		},
		timeHandle() {
			this.getMobileCodeState = true
			this.getMobileCodeTimeHandle = setInterval(() => {
					this.getMobileCodeTime--;
					if(this.getMobileCodeTime == 0) {
							clearInterval(this.getMobileCodeTimeHandle)
							this.getMobileCodeTime = 60;
							this.getMobileCodeState = false
					}
			}, 1000)
		},
		changeCity(id) {
			this.$set(this.formData, 'province', id)
		},
		...mapMutations({
			setUserInfo: types.SET_CURRENT_USER_INFO,
		}),
		...mapActions(['getMenuListApi'])
    }
}
</script>

<style>
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
</style>
<style lang="scss" scoped>
	.informationForm{
		width: 464px;
		margin: 0 auto;
		.imgBtn{
			width:92px;
			height: 50px;
			line-height: 50px;
			text-align: center;
			color: #fff;
			border-radius: 12px;
			background-color: rgba(84, 84, 138, 1);
		}
		::v-deep .el-input__inner{
			background-color: rgba(36, 36, 58, 1);
			border: none;
			line-height: 50px !important;
			height: 50px !important;
			color: #fff
		}
		::v-deep .el-textarea__inner{
			background-color: rgba(36, 36, 58, 1);
			border: none;
			line-height: 50px !important;
			height: 50px !important;
			color: #fff
		}
		::v-deep .el-input__count{
			padding: 5px;
			line-height: 20px;
			height: 20px;
			right: 5px
		}
		::v-deep .el-form-item__label{
			color: #fff;
			margin-bottom: 12px;
			display: block;
			line-height: 22px;
			padding-bottom: 0
		}
		.tip{
			line-height: 50px;
			color: rgba(118, 118, 149, 1);
			margin-left: 8px;
		}
		.btn{
			height: 50px;
			line-height: 50px;
			text-align: center;
			color: rgba(255, 255, 255, 1);
			background-color: rgba(84, 84, 138, 1);
			border-radius: 12px;
			cursor: pointer;
		}
		.avatar{
			width: 50px;
			height: 50px;
			border-radius: 50%;
			margin-right: 13px
		}
		.moblie{
			display: flex;
			.moblieInput{
				flex: 1;
			}
			.getMoblieBtn{
				width: 100px;
				margin-left: 10px;
				border: none;
				padding: 0
			}
		}
	}
	.bannerUrls{
		overflow: hidden;
		.bannerUrlsItem{
			float: left;
			margin: 0 10px 10px 0;
			width: 100px;
			height: 100px;
			position: relative;
			img{
				display: block;
				width: 100%;
				height: 100%
			}
			.close{
				width: 30px;
				height: 30px;
				border-radius: 50%;
				position: absolute;
				right: 5px;
				top: 5px;
				cursor: pointer;
				background: url('../../../assets/images/close.png') center center / 100% 100% no-repeat;
			}
		}
	}
	::v-deep .el-input__count{
		background-color: transparent !important;
		color: #fff
	}
</style>
